<div class="order-details">
  <div class="row">
    <div class="col m4 mb-20">
      <input type="text" matInput (keyup)="applyFilter($event)" placeholder="Search Order Details" />
    </div>
  </div>

  <table
    mat-table
    #outerSort="matSort"
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8"
    matSort
  >
    <ng-container matColumnDef="shipToAccountNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-10">Account Number</th>
      <td mat-cell *matCellDef="let element">{{ element.shipToAccountNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="upc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>UPC</th>
      <td mat-cell *matCellDef="let element">{{ element.upc }}</td>
    </ng-container>
    <ng-container matColumnDef="jobtype">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PO Number</th>
      <td mat-cell *matCellDef="let element">{{ element.poNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="orderType">
      <th mat-header-cell *matHeaderCellDef>Job Type</th>
      <td mat-cell *matCellDef="let element">{{ forBoardCheck(element.orderType) }}</td>
    </ng-container>
    <ng-container matColumnDef="patientName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Patient Name</th>
      <td mat-cell *matCellDef="let element">{{ element.patientName }}</td>
    </ng-container>
    <ng-container matColumnDef="rxId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>RX Order Id</th>
      <td mat-cell *matCellDef="let element">{{ element.rxId }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.status; else showPending">
          <span
            [ngClass]="{
              'has-error': element.status?.toLowerCase() === 'false',
              'has-success': element.status?.toLowerCase() === 'true'
            }"
            [matTooltip]="element.status?.toLowerCase() === 'false' ? element.orderInfo.message : ''"
          >
            {{ element.status?.toLowerCase() === 'true' ? 'Submitted' : 'Failed' }}
          </span></ng-container
        ><ng-template #showPending><span class="has-warning"> Pending</span></ng-template>
      </td>
    </ng-container>
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element" class="w-10">
        <button
          class="btn btn-primary"
          [disabled]="element.status?.toLowerCase() === 'false' || !element.status"
          (click)="expandOrder = expandOrder === element ? null : element; $event.stopPropagation()"
        >
          Details
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
        <div class="example-element-detail" [@detailExpand]="element == expandOrder ? 'expanded' : 'collapsed'">
          <ng-container *ngIf="element.status?.toLowerCase() !== 'false'">
            <ecp-my-orders-detail-card [order]="element.orderInfo"></ecp-my-orders-detail-card>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplayWithExpand"
      class="example-element-row"
      [class.example-expanded-row]="expandOrder === element"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>

  <mat-paginator #outerPaginate="matPaginator" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons> </mat-paginator>
</div>
